import React from "react";
import { TextField } from "office-ui-fabric-react/lib/TextField";

const Input = props => {
  const { name, value, icon, label, placeholder, type, touched, error, style } = props;

  return (
    <div style={style}>
      <TextField
        defaultValue={value}
        onChanged={val => props.onChange(name, val)}
        label={label}
        type={type}
        iconProps={{ iconName: icon }}
        placeholder={placeholder}
      />
      {!!error && touched && <div className="error-message">{error}</div>}
    </div>
  );
};

export default Input;



// WEBPACK FOOTER //
// ./src/common/Dropdowns/_Input.js